import React from 'react';
import {useEffect,useState } from 'react';
import './ShrineInformationStyle.scss';
import { Link } from 'react-router-dom';
import architecture from '../../assets/icons/architecture.png';
import  hewnStone from '../../assets/icons/hewnStone.png';
import { useNavigate } from "react-router-dom";
const firstMenuItem=[
  {
    "id": "e794ce44-9f4d-4bab-b945-71dae8cc943a",
    "title": "درباره امام زاده",
    "href": "/ShrineInformation/AboutImamzadeh",
    "iconPath": "http://khorshidpishva.com:8080/Icons/ShrineInformation.png"
  },
  {
    "id": "e794ce44-9f4d-4bab-b945-71dae8cc943a",
    "title": "کتیبه ها",
    "href": "/ShrineInformation/Katibe",
    "iconPath": hewnStone
  },
  {
    "id": "e794ce44-9f4d-4bab-b945-71dae8cc943a",
    "title": "معماری حرم",
    "href": "/ShrineInformation/Architecture",
    "iconPath": architecture
  },
  {
    "id": "e794ce44-9f4d-4bab-b945-71dae8cc943a",
    "title": "ضریح",
    "href": "/ShrineInformation/Zarih",
    "iconPath": "http://khorshidpishva.com:8080/Icons/Quran-1.png"
  }
]

const ShrineInformation = () => {
  const nav = useNavigate();
  return (
<div className='shrine-information-menu col-12 col-md-12 row'>
{firstMenuItem.map((menu,index) => {
  
     return( 
    <div key={index}  className='section col-md-6 col-10 justify-content-center text-center mt-md-5' >
      <div className='information-menu-box d-flex flex-column align-items-center justify-content-center col-12' onClick={()=>{nav(menu.href)}}>
          <div className='col-10'>
          <img  src={menu.iconPath} className='col-6 col-md-4' alt="" />
          </div>

          <div className='textMenu-Section col-12'>
            <span>
            {menu.title}
            </span>
          </div>
          </div>
  </div>)
})}

</div>

  )
}
export default ShrineInformation;